import React from 'react';
import './TankTesting.css'; // Create a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/peso_dummy_1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_tank_testing_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaFlask, FaShieldAlt, FaCogs, FaGavel, FaComments, FaFileAlt, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function TankTesting() {
  const benefits = [
    {
      icon: <FaFlask />,
      title: 'Enhanced Safety',
      text: 'Ensure the safety of tanks used for explosive materials through rigorous testing.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Regulatory Compliance',
      text: 'Adhere to legal requirements for explosive material storage and transportation.',
    },
    {
      icon: <FaCogs />,
      title: 'Operational Reliability',
      text: 'Identify and mitigate potential issues in tanks to prevent accidents.',
    },
    {
      icon: <FaGavel />,
      title: 'Avoid Legal Penalties',
      text: 'Stay compliant with explosive safety regulations and avoid fines.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Understand your tank testing requirements for explosive materials.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Review',
      description: 'Collect and review relevant documents for tank testing certification.',
    },
    {
      icon: <FaFlask />,
      title: 'Tank Testing',
      description: 'Conduct a detailed inspection and testing of the tanks as per safety standards.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Report Submission',
      description: 'Provide a detailed report with the test results and recommendations.',
    },
    {
      icon: <FaCertificate />,
      title: 'Certificate Issuance',
      description: 'Issue a certification for tanks meeting safety and regulatory standards.',
    },
  ];

  const acts = [
    'Explosives Act, 1884',
    'Petroleum Rules, 2002',
    'Gas Cylinder Rules, 2016',
    'Static and Mobile Pressure Vessels Rules, 1981',
  ];

  const explanation =
    'Tank Testing for explosive materials is essential for ensuring the safety, operational reliability, and compliance of storage tanks. Adherence to these acts ensures that tanks meet strict standards to prevent accidents and protect lives.';

  const checklistItems = [
    { name: 'Tank Design Documents', description: 'Provide details of tank design and specifications.' },
    { name: 'Previous Test Reports', description: 'Include reports from previous tank tests, if available.' },
    { name: 'Inspection Records', description: 'Submit maintenance and inspection records of the tanks.' },
    { name: 'Explosives License Copy', description: 'Attach a valid copy of the explosives storage license.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Tank Testing Certificate (Explosive)"
        subheading="Ensure the safety and compliance of tanks used for explosive materials with our expert services."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact' }}
        ctaSecondary={{ text: 'Learn More', link: '/learn-more' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Tank Testing for Explosives?"
        description="Tank testing ensures the safety, compliance, and operational reliability of tanks used for storing and transporting explosive materials. Our services help you meet regulatory standards efficiently."
        image={img_tank_testing_banner} // Replace with a relevant image
        altText="Tank Testing Process"
      />

      <ServicesBenefitsSection
        title="Why Conduct Tank Testing?"
        description="Understand the importance of tank testing for explosive material safety and regulatory compliance."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Standards for Explosive Safety"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Tank Testing Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Tank Testing Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
